import { render, staticRenderFns } from "./DishPrices.vue?vue&type=template&id=21a25fb0"
import script from "./DishPrices.vue?vue&type=script&lang=js"
export * from "./DishPrices.vue?vue&type=script&lang=js"
import style0 from "./DishPrices.vue?vue&type=style&index=0&id=21a25fb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports